import React, { ReactNode } from 'react';
import { Typography } from 'glints-aries/es/@next';
import { Blue, Neutral } from 'glints-aries/es/@next/utilities/colors';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import useCandidateUrl from '../../../../common/hooks/useCandidateUrl';
import { getConfig } from '../../../../config';

const TermsLink = styled.a`
  color: ${Blue.S99};

  &:hover {
    color: ${Blue.S100};
  }
`;

export const TermsAgreementText = () => {
  const config = getConfig();
  const isEnglishLanguage = config.LANG === 'en';
  const candidateUrl = useCandidateUrl();
  return (
    <Typography
      variant="subtitle2"
      color={Neutral.B40}
      style={{
        backgroundColor: Neutral.B99,
        padding: '12px 16px',
        borderRadius: '4px',
        textAlign: 'start',
      }}
    >
      <FormattedMessage
        id="text-by-continuing"
        defaultMessage="By continuing, you confirm that you accept and will use this purchase according to our <link>Terms of Service</link>."
        values={{
          link: (chunks: ReactNode) => (
            <TermsLink
              href={`${candidateUrl}${
                isEnglishLanguage ? '/en' : ''
              }/about/terms`}
              target="_blank"
              rel="noreferrer"
            >
              {chunks}
            </TermsLink>
          ),
        }}
      />
    </Typography>
  );
};
